import {
  TypographyName, Button, ButtonColor, Modal, ModalSize,
} from '@doveit/lego';
import React, { FunctionComponent, useCallback, useState } from 'react';
import PageSection from '../../../components/page-section/PageSection';
import SavingCalculator from '../../../components/saving-calculator/SavingCalculator';
import CreateLead from '../../../containers/create-lead/CreateLead';
import { sendLeadSubmitEventAndRedirect } from '../../../utils/tracking';

export interface SavingCalculatorBlockProps {
  title: string,
  description: string,
  priceLabel?: string,
  claim?: string,
  cta: string,
  dataTracking?: string,
  dataRef?: string,
}

const SavingCalculatorBlock: FunctionComponent<SavingCalculatorBlockProps> = ({
  title,
  description,
  priceLabel,
  claim,
  cta,
  dataRef = 'saving-calculator-cta',
  dataTracking = 'saving-calculator-cta',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <PageSection padding={[0]}>
      <PageSection.Wrapper withoutPad>
        <PageSection.Title
          content={title}
          size={TypographyName.H3}
        />
        <PageSection.Description
          text={description}
          size={TypographyName.BODY}
          color="neutrals.dark"
        />
        <PageSection.Block>
          <SavingCalculator
            priceLabel={priceLabel ?? undefined}
            compact
          />
        </PageSection.Block>
        <PageSection.Actions
          claim={claim}
          inline
        >
          <Button
            dataTracking={dataTracking}
            dataRef={dataRef}
            label={cta}
            color={ButtonColor.SECONDARY}
            onClick={openModal}
          />
        </PageSection.Actions>

        <Modal
          open={isOpen}
          size={ModalSize.MEDIUM}
          onCloseHandler={closeModal}
          dataRef="lead-modal"
        >
          <Modal.Close />
          <Modal.Header title="Risparmia con dove.it" />
          <Modal.Body padded>
            <CreateLead
              dataRef="lead-form-modal"
              dataTracking="lead-form-modal-submit"
              onSuccess={(lead) => sendLeadSubmitEventAndRedirect(`modal:${dataRef}`, lead)}
            />
          </Modal.Body>
        </Modal>
      </PageSection.Wrapper>
    </PageSection>
  );
};

export default SavingCalculatorBlock;
